import { render } from "./TranslationValueItem.vue?vue&type=template&id=3c009a47"
import script from "./TranslationValueItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TranslationValueItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./TranslationValueItem.vue?vue&type=style&index=0&id=3c009a47&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__